import { PearBox } from '@dealstack/frontend/shared/components/PearBox/PearBox';
import { PROFILE_ROUTES } from '@dealstack/frontend/shared/components/Profile/Profile';
import { useProfileSidebarMenuController } from '@dealstack/frontend/shared/components/Profile/useProfileSidebarMenuController';
import { useAppType } from '@dealstack/frontend/shared/mechanism/appTypeContext/appTypeContext';
import { useTranslationUserProfiles } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { PROJECT } from '@dealstack/shared/lib/common/environment';
import { INVESTOR_TEST_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const ProfileSidebarMenu = ({ className }: Props) => {
	const controller = useProfileSidebarMenuController();
	const { onChangeTabClicked, checkIsTabSelected } = controller;
	const tUserProfiles = useTranslationUserProfiles();
	const appType = useAppType();
	const isInvestorApp = appType === PROJECT.INVESTOR;
	return (
		<div className={className}>
			<PearBox
				onClick={() => {
					onChangeTabClicked(PROFILE_ROUTES.PERSONAL_DETAILS);
				}}
				isSelected={checkIsTabSelected(PROFILE_ROUTES.PERSONAL_DETAILS)}
				icon="user-profile"
				text={tUserProfiles('account_management.sidebar.personal_details')}
				data-testid={INVESTOR_TEST_ELEMENT_ID.USER_PROFILE_SIDEBAR_MENU_PERSONAL_DETAILS}
			/>
			{isInvestorApp && (
				<PearBox
					onClick={() => {
						onChangeTabClicked(PROFILE_ROUTES.BANKING_DETAILS);
					}}
					isSelected={checkIsTabSelected(PROFILE_ROUTES.BANKING_DETAILS)}
					icon="buildings"
					text={tUserProfiles('account_management.sidebar.banking_details')}
					data-testid={INVESTOR_TEST_ELEMENT_ID.USER_PROFILE_SIDEBAR_MENU_BANKING_DETAILS}
				/>
			)}
			<PearBox
				onClick={() => {
					onChangeTabClicked(PROFILE_ROUTES.ACCOUNT_SETTINGS);
				}}
				isSelected={checkIsTabSelected(PROFILE_ROUTES.ACCOUNT_SETTINGS)}
				icon="settings"
				text={tUserProfiles('account_management.sidebar.account_settings')}
				data-testid={INVESTOR_TEST_ELEMENT_ID.USER_PROFILE_SIDEBAR_MENU_ACCOUNT_SETTINGS}
			/>

			{/*//TODO PersonHarmonization, temporary disabled until we have redesigned frontend for multiple PIV's d.zghinnik 4.07.2025*/}
			{/*{hasVehicleData && isInvestorApp && (*/}
			{/*	<PearBox*/}
			{/*		onClick={() => {*/}
			{/*			onChangeTabClicked(PROFILE_ROUTES.PIV_DETAILS);*/}
			{/*		}}*/}
			{/*		isSelected={checkIsTabSelected(PROFILE_ROUTES.PIV_DETAILS)}*/}
			{/*		icon={'mentor-onboard-join-hand-shake'}*/}
			{/*		text={tUserProfiles('account_management.sidebar.piv')}*/}
			{/*		data-testid={INVESTOR_TEST_ELEMENT_ID.USER_PROFILE_SIDEBAR_MENU_PIV_DETAILS}*/}
			{/*	/>*/}
			{/*)}*/}
		</div>
	);
};

const Memoized = memo(ProfileSidebarMenu);
const Styled = styled(Memoized)`
	${PearBox}:hover {
		cursor: pointer;
	}
`;

export { Styled as ProfileSidebarMenu };
